module.exports = __webpack_public_path__ + "static/img/cont47 (1).7b9e0fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont47 (1).jpg
// module id = 93Wu
// module chunks = 0